export default __webpack_public_path__ + "5605f23078257ea45a75176bb465ef41.png";